import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Img
import freeTrialBanner from "../assets/png/free-trial-banner.png";
import freetrialbanner2 from "../assets/png/free-trial-banner-2.png";

// Jds
import { Button, Container, ContentLayout, Selectors, Text } from "@jds/core";

// MUI
import { Box, Modal, Stack } from "@mui/material";

// Local
import EmptyState from "../components/NoData/EmptyState";
import EventCard from "../components/UI/Cards/EventCard";
import useApiHttp from "../hooks/use-http";
import { baseToImg, getCookie } from "../util/helper";
import PageLoader from "../components/UI/Loader/PageLoader";
import JdsModal from "../components/UI/JdsModal";
import SuccessModal from "../components/UI/SuccessModal/SuccessModal";
import Loader from "../components/UI/Loader/Loader";
import TestEventCard from "../components/UI/Cards/TestEventCard";
import decryptUrl from "../util/img-decryption";
import encryptUrl from "../util/img-encryption";
import encryptString from "../util/img-encryption";
import { setIsAdmin } from "../store/state-slices/userRole";
import {
  setFreeTrialModalClose,
  setPlanModalClose,
} from "../store/state-slices/plans";
import CreateNewEventForm from "../components/UI/Form/CreateNewEventForm";
import FAQ from "../components/FAQ/FAQ";
import CreateNewEvent from "../components/CreateNewEvent/CreateNewEvent";

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { eventList: eventListTrigger } = useSelector(
    (state) => state.apiTrigger,
  );
  const { freeTrialModalClose } = useSelector((state) => state.plans);
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );

  const [eventList, setEventList] = useState([]);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [isCreateModalClose, setCreateModalClose] = useState(true);
  const [eventId, setEventId] = useState("");
  const [successModal, setSuccessModal] = useState(true);
  const [tabValue, setTabValue] = useState(() => {
    if (location?.state?.photographerTab) {
      return 1;
    } else {
      return 0;
    }
  });
  const [dynamicFormHead, setDynamicFormHead] = useState(true);
  const [expired, setExpired] = useState(false);
  const [storageDetail, setStorageDetail] = useState();

  const [newUserModalClose, setNewUserModalClose] = useState(true);

  const { isLoading: eventListLoadin, sendRequest: getEventList } =
    useApiHttp();
  const { isLoading: isStorageDetailsLoading, sendRequest: getStorageDetails } =
    useApiHttp();

  const culumData = (data) => {
    if (page === 0 && data?.results) {
      if (data?.results?.length > 0) {
        setEventList(data?.results);
        setLastPage(data?.lastPage);
      }
    } else {
      if (data?.results?.length > 0) {
        setEventList((pre) => [...pre, ...data?.results]);
        setLastPage(data?.lastPage);
      }
    }
  };

  const getEventListHadler = () => {
    getEventList(
      {
        url: `event/event-list?page=${page}&size=25`,
        method: "GET",
      },
      null,
      culumData,
    );
  };

  const getPhotographerEventListHandler = () => {
    getEventList(
      {
        url: `event/photographer/event-list?page=${page}&size=25`,
        method: "GET",
      },
      null,
      culumData,
    );
  };

  // const getStorageDetailsHandler = () => {
  //   getStorageDetails(
  //     {
  //       url: "storage/user",
  //       base: "MEDIA",
  //     },
  //     null,
  //     (data) => {
  //       setStorageDetail(data?.data);
  //     }
  //   );
  // };

  const handleTabChange = (value, i) => {
    if (i !== tabValue) {
      setTabValue(i);
      setEventList([]);
      setPage(0);
    }
    if (value == "photographer-list") {
      // getPhotographerEventListHandler();
      dispatch(setIsAdmin(false));
    } else {
      dispatch(setIsAdmin(true));
      // getEventListHadler();
    }
  };

  // useEffect(() => {
  //   getStorageDetailsHandler();
  // }, []);

  useEffect(() => {
    if (tabValue == 0) {
      getEventListHadler();
    }
    if (tabValue == 1) {
      getPhotographerEventListHandler();
    }
  }, [page, tabValue]);

  useEffect(() => {
    const handleScroll = (e) => {
      const scrollHeight = document?.querySelector("#root-layout").scrollHeight;
      const currentHeight =
        document?.querySelector("#root-layout").scrollTop + window.innerHeight;
      if (currentHeight + 300 >= scrollHeight && page < lastPage) {
        setPage(page + 1);
      }
    };
    document
      ?.querySelector("#root-layout")
      ?.addEventListener("scroll", handleScroll);
    return () => {
      // document?.querySelector("#root-layout") &&
      document
        ?.querySelector("#root-layout")
        ?.removeEventListener("scroll", handleScroll);
    };
  }, [page, lastPage]);

  useEffect(() => {
    if (tabValue == 0) {
      if (page != 0) {
        setPage(0);
      } else {
        getEventListHadler();
      }
      dispatch(setIsAdmin(true));
    }
  }, [eventListTrigger]);

  useEffect(() => {
    if (
      storageDetail?.planType === "FREE_TRIAL_AVAILABLE" &&
      eventList.length == 0 &&
      tabValue == 0
    ) {
      setNewUserModalClose(false);
    }
  }, [storageDetail, eventList]);

  // useEffect(() => {
  //   fetch(
  //     "https://jaws-sit-dl.tejdrive.com/download/autnshr/files/8d3326c10aa14a729924bff7803e39e5?sharekey=Frz36pPNeQeClbrpGDA-8hTtiU3dpztkJx7-6CHLZTs%3DLxX&uLinkToken=buuGBSNPNyGHHmMzBTQdhYQ3nVfCTbKbFTHGXDAo-irvrfDmMqrK4eXrWzA4AJOCIPZ&type=hl&jevent=Y&apikey=1b48222e-fb62-4198-b8e6-9d059e28db32",
  //     {
  //       method: "GET",
  //     }
  //   )
  //     .then((response) => response.blob())
  //     .then((data) => {
  //       console.log("File downloaded successfully");
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // }, []);
  return (
    <>
      <>
        {/* <FAQ /> */}
        <div className="inner-container">
          <Container
            fullWidth
            flex={1}
            direction="column"
            verticalAlign="center"
            horizontalAlign="center"
            paddingTop={140}
            paddingBottom={64}
            // style={{ marginTop: "86px" }}
            // style={{
            //   height: "calc(100vh - 72px)",
            //   overflow: "auto",
            // }}
          >
            <Container
              fullWidth
              style={{
                marginBottom: "32px",
                paddingLeft: eventList.length >= 3 ? "48px" : 0,
              }}>
              <Container style={{ maxWidth: "450px" }}>
                <Selectors
                  stretch
                  selectedIndex={tabValue}
                  onChange={handleTabChange}
                  items={[
                    {
                      label: "As Organizer",
                      value: "admin-list",
                    },
                    {
                      label: "As Photographer",
                      value: "photographer-list",
                    },
                  ]}
                />
              </Container>
            </Container>
            {eventList.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit,minmax(300px,350px))",
                  justifyContent: eventList.length >= 3 ? "center" : "start",
                  gap: "16px",
                }}>
                {eventList.map((item) => {
                  return (
                    <TestEventCard
                      data={item}
                      role={tabValue == 0 ? "admin" : "photographer"}
                    />
                    // <EventCard
                    //   eventTypeName={item.eventTypeName}
                    //   startDate={item.startDate}
                    //   endDate={item.endDate}
                    //   time={item.time}
                    //   locationName={item.locationName}
                    //   heading={item.name}
                    //   bannerimage={
                    //     item.bannerimage ? baseToImg(item.bannerimage) : ""
                    //   }
                    //   bannerThumbnail={
                    //     item.eventTypeIcon ? baseToImg(item.eventTypeIcon) : ""
                    //   }
                    //   guests={item.attendeeCount}
                    //   // bannerThumbnail={""}
                    //   eventId={item.id}
                    //   eventDetails={item}
                    // />
                  );
                })}
              </div>
            ) : (
              <>
                <EmptyState
                  title={`No Events ${tabValue ? "found!" : ""}`}
                  subtitle={
                    !tabValue &&
                    "Get started by creating an event, inviting guests, and sharing photos."
                  }
                  action={!tabValue}
                  actionClick={() => {
                    setCreateModalClose(false);
                  }}
                />
                <JdsModal
                  close={newUserModalClose}
                  kind="informational"
                  size="large"
                  onClose={() => setNewUserModalClose(true)}>
                  <div>
                    <Stack alignItems={"center"} mb={3}>
                      <Box maxWidth={100}>
                        <img src={freetrialbanner2} />
                      </Box>
                    </Stack>
                    <Stack gap={1}>
                      <Text
                        text="Explore Your Free Trial – 25GB Storage for 30 Days!"
                        appearance="heading-xs"
                      />
                      <Text text="Try our event storage solution now. Start exploring with 30 days of hassle-free storage – free of charge!" />
                      {/* <Box>
                        <Text
                          text="See More Plans"
                          appearance="body-s-link"
                          color="primary-60"
                        />
                      </Box> */}
                    </Stack>
                    <Stack gap={1} mt={2}>
                      <Button
                        label="Get Started Now"
                        fullWidth
                        onClick={() => {
                          setNewUserModalClose(true);
                          setCreateModalClose(false);
                        }}
                      />
                      {/* <Button kind="tertiary" label="How free trials work" fullWidth onClick={() => window.open('/how-free-trial-works', '_blank', 'rel=noopener noreferrer')} /> */}
                      <Button
                        kind="tertiary"
                        label="How free trials work"
                        fullWidth
                        onClick={() => navigate("/how-free-trial-works")}
                      />
                    </Stack>
                  </div>
                </JdsModal>

                {/* <JdsModal
                  header={
                    expired
                      ? ""
                      : dynamicFormHead
                        ? profileDetailsRedux?.userType === "SCHOOL"
                          ? "Student Information Form"
                          : "Guest Information Form"
                        : "Create New Event"
                  }
                  size="m"
                  close={isCreateModalClose}
                  onClose={() => {
                    setCreateModalClose(true);
                  }}
                  kind={"custom"}
                  headerProps={{
                    divider: expired ? "false" : "true",
                  }}>
                  {!isCreateModalClose && (
                    <CreateNewEventForm
                      setSuccessModal={setSuccessModal}
                      setEventId={setEventId}
                      setDynamicFormHead={setDynamicFormHead}
                      setExpired={setExpired}
                    />
                  )}
                </JdsModal> */}

                <Modal
                  open={!isCreateModalClose}
                  onClose={() => {
                    setCreateModalClose(true);
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  sx={{
                    zIndex: "60",
                  }}>
                  <CreateNewEvent
                    setSuccessModal={setSuccessModal}
                    setEventId={setEventId}
                    closeModal={() => {
                      setCreateModalClose(true);
                    }}
                  />
                </Modal>
              </>
            )}
          </Container>
        </div>
        {eventListLoadin && page != 0 && <Loader size="small" />}

        {/* Successmodal */}
        <SuccessModal
          close={successModal}
          onClose={() => {
            setSuccessModal(true);
          }}
          btnAction={() => {
            setSuccessModal(true);
            navigate(`/home/events/event-detail/${eventId}`);
          }}
          btnText="Go to Event"
        />
        <JdsModal
          close={freeTrialModalClose}
          onClose={() => dispatch(setFreeTrialModalClose(true))}
          kind="informational"
          size="large">
          <div>
            <Stack alignItems={"center"} mb={3}>
              <Box maxWidth={100}>
                <img src={freeTrialBanner} />
              </Box>
            </Stack>
            <Stack gap={1}>
              <Text
                text="Enjoy 30 Days of Free Storage – Your 25GB Trial Starts Now!"
                appearance="heading-xs"
              />
              <Text text="Start exploring with 30 days left in your trial. Upgrade now to keep your storage hassle-free." />
              <Box>
                <Text
                  text="See More Plans"
                  appearance="body-s-link"
                  color="primary-60"
                />
              </Box>
            </Stack>
            <Stack gap={1} mt={2}>
              <Button
                label="Upgrade Now"
                fullWidth
                onClick={() => {
                  dispatch(setPlanModalClose(false));
                  dispatch(setFreeTrialModalClose(true));
                }}
              />
              {/* <Button kind="tertiary" label="How free trials work" fullWidth onClick={() => window.open('/how-free-trial-works', '_blank', 'rel=noopener noreferrer')} /> */}
              <Button
                kind="tertiary"
                label="How free trials work"
                fullWidth
                onClick={() => navigate("/how-free-trial-works")}
              />
            </Stack>
          </div>
        </JdsModal>
      </>

      {eventListLoadin && page == 0 && <PageLoader open={eventListLoadin} />}
    </>
  );
}
